export default __webpack_public_path__ + "static/media/Group 8222.4e0a23bc.png";